import StyleToObject from 'style-to-object';
import { camelCase } from './utilities';
export default function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    StyleToObject(style, function (property, value) {
        if (property && value) {
            output[camelCase(property, options)] = value;
        }
    });
    return output;
}
//# sourceMappingURL=index.js.map